/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Carriedoutosworkshoptwochallenges6Inputs */

const de__field_carriedoutosworkshoptwochallenges6 = /** @type {(inputs: _Field_Carriedoutosworkshoptwochallenges6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchgeführt OS-Workshop Two Challenges`)
};

/**

* @param {_Field_Carriedoutosworkshoptwochallenges6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_carriedoutosworkshoptwochallenges6 = /** @type {((inputs?: _Field_Carriedoutosworkshoptwochallenges6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Carriedoutosworkshoptwochallenges6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_carriedoutosworkshoptwochallenges6(inputs)
});
export { _field_carriedoutosworkshoptwochallenges6 as "_field_carriedOutOSWorkshopTwoChallenges" }